<div class="sec-title">
    <h1>Ajouter une soumission</h1>
</div>
<div><a class="btn btn-action" href="/clients" routerLink="/clients" role="button"><i class="bi bi-arrow-90deg-left"></i> retour aux clients</a></div>
<div style="width:100%;">
<form [formGroup]="addSubmissionForm" (ngSubmit)="onSubmit(addSubmissionForm.value)" novalidate>
    
    <fieldset class="col-12 float-lg-left form-group mb-3">
        <legend>Informations Soumission</legend>
        <div class="fieldset-wrap">
            <div class="float-lg-start col-sm-12 col-lg-12">
                <fieldset class="">
                    <legend class="sub-label">Info Client</legend>
                    <div class="infobox fieldset-wrap">
                        <div class="float-lg-start col-sm-12 col-lg-6">
                            <div class="form-group mb-3">
                                <label class="form-label">Client</label>
                                <span>{{clientInfo.client_fname}} {{clientInfo.client_lname}}</span>
                            </div>
    
                            <div class="form-group mb-3">
                                <label class="form-label">Adresse principale</label>
                                <span>{{clientInfo.client_address}} {{clientInfo.client_address2}}, {{clientInfo.client_city}}, {{clientInfo.client_province}}, {{clientInfo.client_postalcode}} {{clientInfo.client_country}}</span>
                            </div>
    
                            <div class="form-group mb-3">
                                <label class="form-label">Langue</label>
                                <span>{{clientInfo.client_language_name}}</span>
                            </div>
                        </div>
                        <div class="float-lg-end col-sm-12 col-lg-6">
                          <div class="mb-3" *ngFor="let contactType of contactTypeList; let i = index;">
                            <label class="form-label">{{contactType.client_contact_type_name}}</label>
                            <div >{{contactType.value || 'N/A'}}</div>
                          </div>  
                        </div>
                    </div>
                  </fieldset>
            </div>
            <div class="float-lg-end col-sm-12 col-lg-12">
                <div class="sub-label"></div>
                <div class="form-group mb-3">
                    <label for="submission_no" classs="form-label">Numéro de soumission</label>
                    <input type="text" class="form-control" name="submission_no" id="submission_no" formControlName="submission_no" value="0-" />
                </div>
            </div>
        </div>
    </fieldset>
    <button type="submit" class="btn btn-primary">Ajouter</button>
</form>
<hr />